import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import './assets/scss/main.scss';
import VueRouter from 'vue-router'

import Home from "./Home";
import Csgo from "./Csgo"
import Art from "./Art"

Vue.use(VueRouter)
Vue.use(Buefy, {
  defaultIconPack: 'fas',
})

const routes= [
  { path: '*', redirect: 'home' },
  {path: '/home', component: Home},
  {path: '/csgo', component: Csgo},
  {path: '/art', component: Art},
  {path: '/youtube', beforeEnter() {location.href = 'https://www.youtube.com/channel/UCMVcXc4UykffXNSKqJEdCwA'}},
  {path: '/scp', beforeEnter() {location.href = 'https://play.google.com/store/apps/details?id=com.jokeypokey.scpScanhunt'}},
  {path: '/app', beforeEnter() {location.href = 'https://play.google.com/store/apps/details?id=com.jokeypokey.scpScanhunt'}},
  {path: '/coolvideo', beforeEnter() {location.href = 'https://youtu.be/VN-_kQfbkm4'}},
  {path: '/mcvid', beforeEnter() {location.href = 'https://youtu.be/VN-_kQfbkm4'}},
  {path: '/plswatch', beforeEnter() {location.href = 'https://youtu.be/VN-_kQfbkm4'}},
  {path: '/newvideo', beforeEnter() {location.href = 'https://youtu.be/RZY96I842YA'}},
]

const router = new VueRouter({
  routes: routes,
  mode: 'history'
})

new Vue({
  el: '#app',
  router : router,
  render: h => h(App)

})




// WEBPACK FOOTER //
// ./src/main.js